// extracted by mini-css-extract-plugin
module.exports = {"container":"PaginationButton_container__b5Neh","disabled":"PaginationButton_disabled__Vw3cz"};